




























































import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import Modal from '@/components/Modal.vue';
import { networkProbe } from '@/utils/network/instance';
import { LiveState } from '@/utils/network/probe';
import {
    LEVEL_CLASS,
    LEVEL_LABEL,
    LEVEL_MEANING,
    latencyWord,
    level,
    stabilityWord,
} from '@/utils/network/score';

interface Metric {
    label: string;
    value: string;
    hint?: string;
}

/**
 * Semaforo de conexion en la barra superior.
 *
 * La medicion no vive aca: la sonda arranca con el panel y corre en toda
 * vista. Este componente solo la lee, para que el supervisor pueda mirar
 * como esta su red sin abandonar la pantalla operativa.
 */
@Component({ components: { Icon, Modal } })
export default class NetworkIndicator extends Vue {
    live: LiveState | null = null;

    private unsubscribe: (() => void) | null = null;

    mounted() {
        const probe = networkProbe();

        if (probe) {
            this.unsubscribe = probe.onChange((state) => {
                this.live = state;
            });
        }
    }

    beforeDestroy() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    get levelLabel(): string {
        return LEVEL_LABEL[level(this.live ? this.live.score : null)];
    }

    get levelClass(): string {
        return LEVEL_CLASS[level(this.live ? this.live.score : null)];
    }

    get levelMeaning(): string {
        return LEVEL_MEANING[level(this.live ? this.live.score : null)];
    }

    /** El icono se pinta con el nivel: es lo unico que se ve sin abrir nada. */
    get iconClass(): string {
        const map: Record<string, string> = {
            excellent: 'text-green-500 hover:text-green-600',
            good: 'text-teal-500 hover:text-teal-600',
            fair: 'text-yellow-500 hover:text-yellow-600',
            bad: 'text-red-500 hover:text-red-600',
            unknown: 'text-gray-400 hover:text-gray-500',
        };

        return map[level(this.live ? this.live.score : null)];
    }

    get title(): string {
        return `Tu conexión: ${this.levelLabel}`;
    }

    get metrics(): Metric[] {
        const state = this.live as LiveState;
        const { udp } = state;
        const usaUdp = state.udpEnabled && udp?.ok === true;

        const jitter = usaUdp ? udp?.jitterAvg : state.jitter;
        const rtt = usaUdp ? udp?.rttAvg : state.rtt;

        const metrics: Metric[] = [
            { label: 'Demora', value: this.ms(rtt), hint: latencyWord(rtt) },
            { label: 'Estabilidad', value: this.ms(jitter), hint: stabilityWord(jitter) },
            { label: 'Cortes', value: String(state.timeouts) },
            { label: 'Desconexiones', value: String(state.reconnects) },
        ];

        if (usaUdp) {
            metrics.unshift({ label: 'Audio perdido', value: `${udp?.lossPct}%` });
        }

        return metrics;
    }

    toogle() {
        (this.$refs.modal as Modal).toogleModal();
    }

    async testNow() {
        const probe = networkProbe();

        if (!probe) {
            return;
        }

        await probe.testNow();
        // el estado se refresca por la suscripcion, pero si la sonda quedo
        // sin listeners por un remount conviene leerlo una vez mas
        this.live = probe.state();
    }

    // eslint-disable-next-line class-methods-use-this
    ms(value: number | null | undefined): string {
        return value === null || value === undefined ? '-' : `${value} ms`;
    }
}
